let saveScrollY = 0

export function disableScroll() {
  const element = document.documentElement
  const scrollY = window.scrollY
  saveScrollY = scrollY
  const scrollbarWidth = window.innerWidth - element.clientWidth

  Object.assign(element.style, {
    position: 'fixed',
    top: `-${scrollY}px`,
    left: '0',
    right: '0',
    bottom: '0',
    overflow: 'hidden',
    minHeight: 'initial',
    height: 'auto',
  })

  if (scrollbarWidth > 0) {
    element.style.paddingRight = `${scrollbarWidth}px`
  }
}

export function enableScroll() {
  const element = document.documentElement
  const scrollY = parseInt(saveScrollY, 10) || 0

  Object.assign(element.style, {
    position: '',
    top: '',
    left: '',
    right: '',
    bottom: '',
    overflow: '',
    minHeight: '',
    height: '',
    paddingRight: '',
  })
  window.scrollTo(0, scrollY)
}
